<footer class="app-footer">
  <div class="app-footer__grid">
    <div class="app-footer__col app-footer__brand-col">
      <a [routerLink]="routes.HOME" class="app-footer__brand">
        <img src="/assets/images/logo3.png" alt="Amaalmomineen - Your Companion in Imaan" class="app-footer__logo-img" />
      </a>
      <p class="app-footer__description">
        {{ 'footer.description' | translate }}
      </p>
      <div class="app-footer__social">
        @for (social of socialLinks; track social.label) {
          <a class="app-footer__social-link" [href]="social.url" target="_blank" rel="noopener" [attr.aria-label]="social.label">
            {{ social.icon }}
          </a>
        }
      </div>
    </div>

    <div class="app-footer__col">
      <span class="app-footer__heading">{{ 'footer.address_heading' | translate }}</span>
      <ul class="app-footer__contact-list">
        <li>
          <span aria-hidden="true">📍</span>
          <span>123 Imaan Street, Peace City, Bengaluru, Karnataka 560001, India</span>
        </li>
        <li>
          <span aria-hidden="true">✉️</span>
          <span>support&#64;amaalmomineen.com</span>
        </li>
        <li>
          <span aria-hidden="true">📞</span>
          <span>+91 98765 43210</span>
        </li>
      </ul>
    </div>

    <div class="app-footer__col app-footer__sitemap-col">
      <span class="app-footer__heading">{{ 'footer.sitemap_heading' | translate }}</span>
      <div class="app-footer__sitemap-grid">
        @for (column of siteMapColumns; track $index) {
          <ul class="app-footer__link-list">
            @for (link of column; track link.label) {
              <li>
                @if (link.path) {
                  <a [routerLink]="link.path">{{ link.label | translate }}</a>
                } @else {
                  <span class="app-footer__link--disabled">{{ link.label | translate }}</span>
                }
              </li>
            }
          </ul>
        }
      </div>
    </div>

    <div class="app-footer__col">
      <span class="app-footer__heading">{{ 'footer.download_heading' | translate }}</span>
      <p class="app-footer__description">{{ 'footer.download_sub' | translate }}</p>
      <div class="app-footer__store-badges">
        <a href="#" class="app-footer__store-badge">
          <span aria-hidden="true">▶</span>
          <span class="app-footer__store-badge-text">
            <small>{{ 'footer.google_play_pre' | translate }}</small>
            <strong>{{ 'footer.google_play' | translate }}</strong>
          </span>
        </a>
        <a href="#" class="app-footer__store-badge">
          <span aria-hidden="true">🍎</span>
          <span class="app-footer__store-badge-text">
            <small>{{ 'footer.app_store_pre' | translate }}</small>
            <strong>{{ 'footer.app_store' | translate }}</strong>
          </span>
        </a>
      </div>
    </div>
  </div>

  <div class="app-footer__bottom">
    <span>&copy; {{ currentYear }} {{ 'footer.copyright' | translate }}</span>
    <div class="app-footer__legal">
      @for (link of legalLinks; track link.label) {
        <span>{{ link.label | translate }}</span>
      }
    </div>
  </div>
</footer>
